var _rect, _rect2, _rect3, _circle, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMobileDevice = function SvgMobileDevice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.291,
    width: 34.5297,
    height: 55.7788,
    rx: 5.31227,
    transform: "rotate(16.9814 30.291 0)",
    fill: "url(#paint0_linear_409_47184)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0557,
    y: 3.31616,
    width: 29.2175,
    height: 39.842,
    rx: 3.9842,
    transform: "rotate(16.9814 32.0557 3.31616)",
    fill: "url(#paint1_linear_409_47184)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.4516,
    cy: 52.0385,
    r: 2.65613,
    transform: "rotate(16.9814 32.4516 52.0385)",
    fill: "#BBDEFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 30.5,
    cy: 65.5,
    rx: 18.5,
    ry: 1.5,
    fill: "url(#paint2_linear_409_47184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_47184",
    x1: 30.291,
    y1: 15.2728,
    x2: 62.896,
    y2: 38.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_47184",
    x1: 64.5933,
    y1: 5.9723,
    x2: 21.3446,
    y2: 20.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_409_47184",
    x1: 53.2045,
    y1: 64.2,
    x2: 51.2724,
    y2: 74.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMobileDevice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mobile-device.ac51a854a034488d99bd6798c2a512c7.svg";